module.exports = __webpack_public_path__ + "static/media/03keiyou.1ff7f510.png";